// Mounts inside the Router. Measures time spent on each page and records a
// page_view event (with dwell duration) when the user navigates away, hides the
// tab, or closes the page.
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { enqueue, flush } from "@/lib/analytics";

export function AnalyticsTracker() {
  const location = useLocation();
  const enterRef = useRef(Date.now());
  const pathRef = useRef(location.pathname);
  const firstRef = useRef(true);

  // Record dwell for the page we are leaving on each route change.
  useEffect(() => {
    if (firstRef.current) {
      firstRef.current = false;
      pathRef.current = location.pathname;
      enterRef.current = Date.now();
      return;
    }
    const now = Date.now();
    enqueue({ type: "page_view", path: pathRef.current, duration_ms: now - enterRef.current });
    flush();
    pathRef.current = location.pathname;
    enterRef.current = now;
  }, [location.pathname]);

  // Capture the final page on unload / tab hide.
  useEffect(() => {
    const record = () => {
      const now = Date.now();
      enqueue({ type: "page_view", path: pathRef.current, duration_ms: now - enterRef.current });
      enterRef.current = now;
      flush();
    };
    const onVisibility = () => { if (document.hidden) record(); };
    window.addEventListener("beforeunload", record);
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      window.removeEventListener("beforeunload", record);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);

  return null;
}
